import * as contentful from 'contentful'
import { createLocalContentfulClient } from './contentful-local'

const contentfulClient =
  process.env.KICKOFF_CANDIDATE_MODE === '1'
    ? createLocalContentfulClient()
    : !!process.env.CONTENTFUL_API_KEY
    ? contentful.createClient({
        space: process.env.CONTENTFUL_SPACE_ID,
        accessToken: process.env.CONTENTFUL_API_KEY,
        host: process.env.CONTENTFUL_HOST,
      })
    : undefined

export default contentfulClient
